/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MoneyWalletAIcon16Light } from './MoneyWalletAIcon16Light';
import { MoneyWalletAIcon16Regular } from './MoneyWalletAIcon16Regular';
import { MoneyWalletAIcon16Solid } from './MoneyWalletAIcon16Solid';
import { MoneyWalletAIcon20Light } from './MoneyWalletAIcon20Light';
import { MoneyWalletAIcon20Regular } from './MoneyWalletAIcon20Regular';
import { MoneyWalletAIcon20Solid } from './MoneyWalletAIcon20Solid';
import { MoneyWalletAIcon24Regular } from './MoneyWalletAIcon24Regular';
import { MoneyWalletAIcon24Solid } from './MoneyWalletAIcon24Solid';
import { MoneyWalletAIcon32Regular } from './MoneyWalletAIcon32Regular';
import { MoneyWalletAIcon64Regular } from './MoneyWalletAIcon64Regular';
var sizes = {
    16: {
        light: MoneyWalletAIcon16Light,
        regular: MoneyWalletAIcon16Regular,
        solid: MoneyWalletAIcon16Solid,
    },
    20: {
        light: MoneyWalletAIcon20Light,
        regular: MoneyWalletAIcon20Regular,
        solid: MoneyWalletAIcon20Solid,
    },
    24: {
        regular: MoneyWalletAIcon24Regular,
        solid: MoneyWalletAIcon24Solid,
    },
    32: {
        regular: MoneyWalletAIcon32Regular,
    },
    64: {
        regular: MoneyWalletAIcon64Regular,
    },
};
export var MoneyWalletAIcon = forwardRef('MoneyWalletAIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
